import React from "react";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { BLOG_POSTS } from "../data/mock";

export function BlogSection() {
  return (
    <section id="blog" className="py-20 bg-[#FAF8F5]" data-testid="blog-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-12 gap-4">
          <div>
            <span className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase">Design Inspiration</span>
            <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#1a1a1a] mt-2">
              Interior Design Blog
            </h2>
            <p className="text-gray-500 mt-2 max-w-md">
              Tips, trends, and ideas for your Hyderabad home
            </p>
          </div>
          <a
            href="/blog"
            className="inline-flex items-center gap-2 text-[#C9A84C] font-semibold hover:gap-3 transition-all"
            data-testid="view-all-blogs-link"
          >
            View All Articles <ArrowRight size={16} />
          </a>
        </div>

        {/* Featured post */}
        <div className="grid lg:grid-cols-5 gap-6 mb-8">
          <div
            className="lg:col-span-3 relative rounded-2xl overflow-hidden group cursor-pointer"
            data-testid="featured-blog-post"
            onClick={() => window.location.href = `/blog/${BLOG_POSTS[0].slug}`}
          >
            <div className="aspect-[16/9]">
              <img
                src={BLOG_POSTS[0].image}
                alt={BLOG_POSTS[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <span className="inline-block bg-[#C9A84C] text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                {BLOG_POSTS[0].category}
              </span>
              <h3 className="font-serif text-xl sm:text-2xl font-bold mb-2">{BLOG_POSTS[0].title}</h3>
              <p className="text-gray-300 text-sm mb-3 line-clamp-2">{BLOG_POSTS[0].excerpt}</p>
              <div className="flex items-center gap-4 text-xs text-gray-400">
                <span className="flex items-center gap-1"><Calendar size={11} />{BLOG_POSTS[0].date}</span>
                <span className="flex items-center gap-1"><Clock size={11} />{BLOG_POSTS[0].readTime}</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-4">
            {BLOG_POSTS.slice(1, 4).map((post) => (
              <BlogCard key={post.id} post={post} compact />
            ))}
          </div>
        </div>

        {/* Bottom grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BLOG_POSTS.slice(3).map((post) => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      </div>
    </section>
  );
}

function BlogCard({ post, compact }) {
  if (compact) {
    return (
      <div
        className="flex gap-4 bg-white rounded-xl p-3 cursor-pointer hover:shadow-md transition-shadow group"
        onClick={() => window.location.href = `/blog/${post.slug}`}
        data-testid={`blog-card-${post.id}`}
      >
        <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
        </div>
        <div className="flex-1 min-w-0">
          <span className="text-[#C9A84C] text-xs font-semibold">{post.category}</span>
          <h4 className="text-sm font-semibold text-[#1a1a1a] mt-0.5 line-clamp-2 leading-snug">{post.title}</h4>
          <div className="flex items-center gap-2 text-xs text-gray-400 mt-1.5">
            <Clock size={10} />{post.readTime}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="bg-white rounded-xl overflow-hidden cursor-pointer hover:shadow-lg transition-shadow group"
      onClick={() => window.location.href = `/blog/${post.slug}`}
      data-testid={`blog-card-${post.id}`}
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
      <div className="p-5">
        <span className="inline-block bg-[#C9A84C]/10 text-[#C9A84C] text-xs font-semibold px-2.5 py-1 rounded-full mb-3">
          {post.category}
        </span>
        <h3 className="font-serif text-base font-bold text-[#1a1a1a] mb-2 leading-snug line-clamp-2">{post.title}</h3>
        <p className="text-gray-500 text-sm line-clamp-2 mb-3">{post.excerpt}</p>
        <div className="flex items-center justify-between text-xs text-gray-400">
          <span className="flex items-center gap-1"><Calendar size={11} />{post.date}</span>
          <span className="flex items-center gap-1"><Clock size={11} />{post.readTime}</span>
        </div>
      </div>
    </div>
  );
}
